module.exports = __webpack_public_path__ + "media/img/illustrations/icons/badge-collab-bank-848d8ea2a1d6e2ae07ebb80ad29255e8.svg";